import React, { useState, useEffect } from 'react';
import './notificationAlert.css';

function NotificationAlert({
  text = "Texto animado subindo!",
  duration = 3000,
  onComplete = () => {}, style = {},
    type = 'default',
}) {
  const [isAnimating, setIsAnimating] = useState(false);
  const [showText, setShowText] = useState(false);

  const startAnimation = () => {
    setShowText(true);
    setIsAnimating(true);

    setTimeout(() => {
      setShowText(false);
      setIsAnimating(false);
      onComplete();
    }, duration);
  };

  useEffect(() => {
    if (text.length >= 1) {
      startAnimation();
    }
  }, [text]);

  const getMessageClass = () => {
    const baseClass = "animated-text-message";
    return `${baseClass} ${type}`;
  };

  return (
    <div style={style} className="relative w-full h-screen bg-gradient-to-br from-blue-400 to-purple-400 overflow-hidden">
      {showText && (
        <div
          className={`
            fixed bottom-0 left-0 right-0 
            flex items-center justify-center
            pointer-events-none
            ${isAnimating ? 'animate-float-up' : ''}
          `}
        >
          <div className={getMessageClass()}>
            {text}
          </div>
        </div>
      )}
    </div>
  );
};

export default NotificationAlert;